import { createFileRoute } from '@tanstack/react-router'
import { LegalPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/accessibility')({
  loader: () =>
    loadPageData({
      data: { kind: 'legal', locale: 'en', params: { legalKind: 'barrierefreiheit' } },
    }),
  head: () => staticRouteHead('accessibility', 'en'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <LegalPage kind="barrierefreiheit" />
    </CatalogProvider>
  )
}
